import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Icons } from '@shopline/dashboard-ui'
import { Checkbox } from '@shopline/dashboard-ui'

const StyledCategoryItemWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  cursor: pointer;
  background-color: ${({ checked }) => (checked ? '#F2F7FF' : 'transparent')};
  padding-left: ${({ layer }) => `${layer * 12}px`};
`

const StyledCheckboxGroup = styled.div`
  width: 80%;
  display: flex;
  align-items: center;

  span {
    margin-left: 4px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`

const StyledChevronDiv = styled.div`
  transform: ${({ isOpen }) => (isOpen ? 'rotate(0deg)' : 'rotate(180deg)')};
`

const CategoryItem = ({ layer, label, checked, isOpen, onClick, onChevronClick, isShowChevron, interminate }) => {
  return (
    <StyledCategoryItemWrapper checked={checked} layer={layer}>
      <StyledCheckboxGroup onClick={onClick}>
        <Checkbox.Primary checked={checked} interminate={interminate} />
        <span>{label}</span>
      </StyledCheckboxGroup>

      {isShowChevron && (
        <StyledChevronDiv onClick={onChevronClick} isOpen={isOpen}>
          <Icons.Outline.Chevron size="MEDIUM" />
        </StyledChevronDiv>
      )}
    </StyledCategoryItemWrapper>
  )
}

CategoryItem.propTypes = {
  layer: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onChevronClick: PropTypes.func,
  isShowChevron: PropTypes.bool,
  indeterminate: PropTypes.bool,
}

export default CategoryItem
